import React from 'react';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { EDULAI_BLUE } from '../../../../styles/styleConsts';

const radioStyle = {
  width: '18px',
  height: '18px',
  border: '1px solid #6B7280',
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  margin: '5px'
};

const innerStyle = {
  width: '14px',
  height: '14px',
  borderRadius: '50%',
  backgroundColor: EDULAI_BLUE,
  transition: 'background-color 0.3s ease'
};

const MDRadioButtonView = ({
  checked,
  colorIndex,
  label,
  value,
  handleChange,
  labelStyle,
  showOption = true,
  showBorder = false
}) => {
  const style = {
    ...(showBorder ? { border: `${1}px solid ${checked ? '#5048E5' : 'transparent'}`, borderRadius: 10 } : {}),
    marginLeft: 0,
    marginRight: 0,
    paddingRight: 14
  };

  return (
    <FormControlLabel
      checked={checked}
      color={colorIndex || 'primary'}
      value={value}
      onChange={(e) => handleChange(e)}
      style={style}
      control={
        <Radio
          icon={
            <div
              style={{
                ...radioStyle,
                ...(showOption ? { opacity: 1 } : { opacity: 0 })
              }}
            >
              <div
                style={{
                  ...innerStyle,

                  backgroundColor: 'transparent'
                }}
              />
            </div>
          }
          checkedIcon={
            <div style={radioStyle}>
              <div style={innerStyle} />
            </div>
          }
        />
      }
      label={<h5 style={{ ...labelStyle }}>{label}</h5>}
    />
  );
};

export default MDRadioButtonView;
